import './App.css';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Guides from './pages/Guides';
import Contact from './pages/Contact';
import BannerSlider from './components/BannerSlider';
import SharePage from './components/SharePage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Router>
      <ScrollToTop />
      <div className="App flex flex-col min-h-screen bg-slate-50 text-slate-900 pt-[112px]" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
        <Navbar />
        <BannerSlider />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/guides" element={<Guides />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <SharePage />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
